(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chat-widget"] && !Shopify.designMode) return;
  try {
    /* Two belts, because the first one leans on a variable name that belongs to
     Shopify and can be renamed under us:

     1. we hand the widget our clearance through its own offset variable, on the
        host above and from a stylesheet injected into its shadow root here.
        Document stylesheets do not cross a shadow boundary, so everything
        inside merely inherits the host value, and that falls apart the moment
        the chat is opened: it swaps the activator for a <shopify-agent-runtime>
        carrying inline copies of the variables, and inline outranks inherited.
        An important declaration from inside the shadow root beats it, and keeps
        beating it however often the widget re-renders.

     2. we measure where the closed button actually lands and lift it by exactly
        what it overlaps. That one holds whatever they rename, and it is what
        recovers the placement when belt 1 stops matching their internals. */

  const CHAT_TAG = 'shopify-chat';

  const probe = document.createElement('div');
  probe.className = 'chat-clearance-probe';
  (document.body || document.documentElement).append(probe);

  const clearance = () => probe.getBoundingClientRect().height;

  const liftActivator = (shadowRoot) => {
    /* Closed state only. Once the chat is open the button is gone, the panel is
       meant to cover the screen, and the transform goes with the element it was
       written on. */
    const button = shadowRoot.querySelector('button');

    if (!button) return;

    /* measure the button, move its wrapper: the wrapper is the positioned box,
       while the button itself may carry the widget's own hover transform */
    const target = button.parentElement || button;

    target.style.removeProperty('transform');

    const overlap = button.getBoundingClientRect().bottom - (window.innerHeight - clearance());

    if (overlap > 0) {
      target.style.setProperty('transform', `translateY(${-overlap}px)`, 'important');
    }
  };

  let watching = false;

  const fitChatToTheme = () => {
    const shadowRoot = document.querySelector(CHAT_TAG)?.shadowRoot;

    if (!shadowRoot) return false;

    if (!watching) {
      watching = true;

      const style = document.createElement('style');
      style.textContent = '* { --shopify-agent-activator-offset: var(--chat-clearance) !important; }';
      shadowRoot.append(style);

      /* the widget rebuilds its insides while loading, on open and on close.
         Only childList is observed, so writing the transform back does not
         wake the observer up again. */
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          liftActivator(shadowRoot);
        });
      }).observe(shadowRoot, { childList: true, subtree: true });

      const remeasure = () => liftActivator(shadowRoot);
      window.addEventListener('resize', remeasure);
      window.visualViewport?.addEventListener('resize', remeasure);
      /* the buy bar changes height when the price wraps onto a second line */
      document.addEventListener('theme:sticky-bar-resize', remeasure);
    }

    liftActivator(shadowRoot);

    return true;
  };

  const waitForChat = () => {
    if (fitChatToTheme()) return;

    /* the element can be defined a moment before it is in the document with a
       shadow root of its own */
    const poll = setInterval(() => {
      if (fitChatToTheme()) clearInterval(poll);
    }, 300);
    setTimeout(() => clearInterval(poll), 60000);
  };

  /* nothing runs at all on stores with the embed disabled: the promise never
     settles, so there is no polling to pay for */
  if (customElements.get(CHAT_TAG)) waitForChat();
  else customElements.whenDefined(CHAT_TAG).then(waitForChat);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collapsible-row"] && !Shopify.designMode) return;
  try {
    // Bursts oranges when a collapsible opens, and closes the sibling rows on
  // browsers without native `<details name>` exclusivity. The `toggle` event
  // does not bubble, so the listener runs in the capture phase.
  if (!window.collapsibleRowReady) {
    window.collapsibleRowReady = true;

    const supportsExclusive = 'name' in document.createElement('details');

    document.addEventListener(
      'toggle',
      (event) => {
        const row = event.target;
        if (!row.open || !row.hasAttribute?.('citrus-spill')) return;

        const group = row.getAttribute('name');
        if (!supportsExclusive && group) {
          document.querySelectorAll(`details[name="${group}"][open]`).forEach((other) => {
            if (other !== row) other.open = false;
          });
        }

        // burst from the row the visitor actually clicked
        const summary = row.querySelector('summary') || row;
        summary.dispatchEvent(new CustomEvent('citrus:spill', { bubbles: true }));
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.querySelector('[name="minus"]').addEventListener('click', () => this.step(-1));
        this.querySelector('[name="plus"]').addEventListener('click', () => this.step(1));
      }

      step(delta) {
        const min = this.input.min === '' ? 0 : Number(this.input.min);
        const max = this.input.max === '' ? Infinity : Number(this.input.max);
        const next = Math.min(max, Math.max(min, Number(this.input.value || 0) + delta));
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    customElements.define('quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('share-buttons')) {
    class ShareButtons extends HTMLElement {
      connectedCallback() {
        this.url = this.dataset.shareUrl;
        this.title = this.dataset.shareTitle;
        this.status = this.querySelector('[data-share-status]');

        const nativeButton = this.querySelector('[data-share-native]');
        const copyButton = this.querySelector('[data-share-copy]');

        if (navigator.share && nativeButton) {
          nativeButton.hidden = false;
          nativeButton.addEventListener('click', () => this.shareNative());
        }

        // Only the Facebook link goes away, and only on a touch device that has
        // the native sheet to replace it: the WhatsApp link opens its app from
        // the browser everywhere, so there is nothing to withdraw there.
        const facebookLink = this.querySelector('[data-share-facebook]');
        if (facebookLink && navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          facebookLink.hidden = true;
        }

        if (navigator.clipboard && copyButton) {
          copyButton.hidden = false;
          copyButton.addEventListener('click', () => this.copyLink());
        }
      }

      async shareNative() {
        try {
          await navigator.share({ title: this.title, url: this.url });
        } catch (error) {
          // Dismissing the sheet rejects the promise; that is not a failure.
        }
      }

      async copyLink() {
        try {
          await navigator.clipboard.writeText(this.url);
          this.announce(this.dataset.copiedLabel);
        } catch (error) {
          // Clipboard writes can be denied by permissions; stay silent.
        }
      }

      announce(message) {
        if (!this.status) return;
        this.status.textContent = message;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.status.textContent = '';
        }, 4000);
      }
    }

    customElements.define('share-buttons', ShareButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
